import { EventSource, EventType } from '../graphql/graphql';
import { Option, pipe, ReadonlyArray } from 'effect';
export const isAdvisorTyping = (events) => {
    const lastAdvisorMessageTimestamp = pipe(events, ReadonlyArray.filter(e => e.type === EventType.Message && e.source !== EventSource.Customer), ReadonlyArray.last, Option.map(ev => ev.persistedTimestamp));
    const lastAdvisorTypingEvent = pipe(events, ReadonlyArray.filter((e) => e.type === EventType.MessagingState), ReadonlyArray.last);
    return Option.match(lastAdvisorMessageTimestamp, {
        onNone: () => lastAdvisorTypingEvent,
        onSome: timestamp => Option.flatMap(lastAdvisorTypingEvent, typingEvent => typingEvent.persistedTimestamp > timestamp
            ? lastAdvisorTypingEvent
            : Option.none()),
    });
};
